var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3969_7069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9423 6L8.99976 7.9425L7.05726 6L5.99976 7.0575L7.94226 9L5.99976 10.9425L7.05726 12L8.99976 10.0575L10.9423 12L11.9998 10.9425L10.0573 9L11.9998 7.0575L10.9423 6ZM8.99976 1.5C4.85226 1.5 1.49976 4.8525 1.49976 9C1.49976 13.1475 4.85226 16.5 8.99976 16.5C13.1473 16.5 16.4998 13.1475 16.4998 9C16.4998 4.8525 13.1473 1.5 8.99976 1.5ZM8.99976 15C5.69226 15 2.99976 12.3075 2.99976 9C2.99976 5.6925 5.69226 3 8.99976 3C12.3073 3 14.9998 5.6925 14.9998 9C14.9998 12.3075 12.3073 15 8.99976 15Z",
    fill: "#D7D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3969_7069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOff);
export default __webpack_public_path__ + "static/media/CancelOff.492e6074c70439fcc122d50d2e74bac3.svg";
export { ForwardRef as ReactComponent };